export default "__VITE_ASSET__C_Ezg$rL__"